import { SVGProps } from 'react'

const Background = (props: SVGProps<SVGSVGElement>) => (
    <svg width='1680' height='827' viewBox='0 0 1680 827' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
        <mask
            id='mask0_502_2761'
            // style='mask-type:alpha'
            maskUnits='userSpaceOnUse'
            x='0'
            y='0'
            width='1680'
            height='827'
        >
            <rect width='1680' height='827' fill='#D9D9D9' />
        </mask>
        <g mask='url(#mask0_502_2761)'>
            <g opacity='0.4' filter='url(#filter0_f_502_2761)'>
                <circle cx='840' cy='30' r='385' fill='url(#paint0_radial_502_2761)' />
            </g>
        </g>
        <defs>
            <filter
                id='filter0_f_502_2761'
                x='155'
                y='-655'
                width='1370'
                height='1370'
                filterUnits='userSpaceOnUse'
                colorInterpolationFilters='sRGB'
            >
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
                <feGaussianBlur stdDeviation='150' result='effect1_foregroundBlur_502_2761' />
            </filter>
            <radialGradient
                id='paint0_radial_502_2761'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='translate(840 30) rotate(90) scale(385)'
            >
                <stop stopColor='#3C3C3C' />
                <stop offset='1' stopColor='#3A3A4D' />
            </radialGradient>
        </defs>
    </svg>
)

export default Background
